import { consumeLoading } from "@/lib/consume/loading"
import { LoadingScreenComponent } from "@/lib/loading/screen/component"

export const LoadingScreenConsumer = consumeLoading(LoadingScreenComponent)
